import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { flameSystemFacts, flames } from "@/mocks/flames";

export default function FlameSystem() {
  return (
    <section id="flame" className="w-full bg-foreground-950 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <Reveal>
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/20 px-3 py-1 text-xs font-medium tracking-wide text-primary-200">
              <span className="h-1.5 w-1.5 rounded-full bg-primary-400" />
              战斗体系
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-background-50 md:text-3xl">
              死气之火：看懂这部作品的战斗逻辑
            </h2>
            <p className="mt-3 text-sm leading-7 text-background-100/75 md:text-base">
              很多观众记得角色的招式，却说不清火焰属性之间的关系。理解这七种属性，就能明白每场战斗为什么那样打，以及队伍为什么需要这样的人员配置。
            </p>
          </div>
        </Reveal>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {flames.map((flame, index) => (
            <Reveal key={flame.id} delay={(index % 4) * 80}>
              <div className="flex h-full flex-col rounded-lg border border-background-100/12 bg-white/5 p-5 transition-colors hover:border-primary-400/50">
                <div className="flex items-center justify-between">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500/20 text-primary-200">
                    <i className="ri-fire-line text-lg" />
                  </span>
                  <span className="font-heading text-2xl font-black text-background-50/15">{String(index + 1).padStart(2, "0")}</span>
                </div>
                <h3 className="mt-4 font-heading text-lg font-bold text-background-50">
                  {flame.name}
                  <span className="ml-2 text-xs font-normal text-background-100/55">{flame.en}</span>
                </h3>
                <div className="mt-2 flex flex-wrap gap-2 text-xs">
                  <span className="rounded-full bg-accent-500/25 px-2.5 py-0.5 text-accent-100">色彩：{flame.color}</span>
                  <span className="rounded-full bg-background-100/10 px-2.5 py-0.5 text-background-100/80">
                    特性：{flame.meaning}
                  </span>
                </div>
                <p className="mt-3 flex-1 text-sm leading-6 text-background-100/70">{flame.desc}</p>
              </div>
            </Reveal>
          ))}

          <Reveal delay={80}>
            <div className="flex h-full flex-col justify-center rounded-lg border border-dashed border-primary-400/40 bg-primary-500/10 p-5">
              <h3 className="font-heading text-base font-bold text-background-50">为什么要分属性？</h3>
              <p className="mt-2 text-sm leading-6 text-background-100/70">
                属性并不是为了好看，它决定了角色在团队中的定位：谁能攻、谁能守、谁负责支援与干扰。看懂分工，才能看懂每一次阵容调整背后的用意。
              </p>
            </div>
          </Reveal>
        </div>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {flameSystemFacts.map((fact, index) => (
            <Reveal key={fact.id} delay={(index % 4) * 80}>
              <div className="rounded-lg bg-white/5 p-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500/25 text-accent-100">
                  <i className={`${fact.icon} text-lg`} />
                </span>
                <h4 className="mt-3.5 font-heading text-base font-bold text-background-50">
                  <a href="#flame" className="hover:text-primary-200">{fact.title}</a>
                </h4>
                <p className="mt-2 text-sm leading-6 text-background-100/70">{fact.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}